"use strict";

import { NgModule } from "@angular/core";
import { TagDataService } from "./tag-data.service";

@NgModule({
  providers: [TagDataService]
})
export class TagDataModule {}
